module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAP1JREFUWEftlzFKA1EURc8RBMFarARRBMGNZAtWugWxsLOxUQtxCzbiDoR0llZ2KYLBZVgYfRL4gTEo5DkwEflTfu5978wd+JeR5BMRm8BLsR2rV8kRX+RmzRGxAwyL70S9zM5o6n8DsAWMypAj9boC1ARqAjWBrhNYAV7L0kP1phVAROwmB2wA/eI5B7IAI/VtutOIiCRAW/lA3VskwFhdbgIcAJODjzle7R1YBy6K9ha4L/5Z+2zRLQFj4EGd1jnpNpxsaXy2ffVuDvAfJWmAiKh1XBOoCdQEFp7ANvD8V/6MTtWzrq/iVeARWAN66lOnAG2WfedNl9G/A/gEquCYIRODgUMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/icon_jia@2x.png
// module id = gn/C
// module chunks = 96